export const name = 'siteLightboxService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-lightbox' as const
